import { OptionItem } from '@app/components/ui/select/select.type';
import useTranslation from '@app/hooks/use-translation';
import {
  GPTIntegrationMutationObject,
  GPTIntegrationObjectType,
  GPTModelsSupportObjectType,
} from '@app/interfaces/settings.type';
import {
  useCreateUserGptIntegrationMutation,
  useEditUserGptIntegrationMutation,
} from '@app/store/api/intergation-settings.api';
import { Button, CustomLabel, Input, Select, Toggle } from '@ui';
import React, { FC, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

type FormType = GPTIntegrationMutationObject;
// {
//     description: string;
//     model: string;
//     api: "openai";
//     api_key: string;
//     model_url: string;
//     max_tokens?: number | undefined;
//     temperature?: number | undefined;
//     logging?: boolean | undefined;
// }
type GptIntegrationFormPropsType = {
  settingsFormData: GPTIntegrationObjectType | undefined;
  supportIntegrations: GPTModelsSupportObjectType | undefined;
  onClose(): void;
};
const GptIntegrationForm: FC<GptIntegrationFormPropsType> = (props) => {
  const { onClose, settingsFormData, supportIntegrations } = props;

  const { t: tf } = useTranslation('common.forms');

  // eslint-disable-next-line
  const { t } = useTranslation('pages.settings.gpt_integrations');
  const modelNames = (supportIntegrations?.models || []).map((model) => model.description);
  const [modelVariant, setModelVariant] = useState<'manual' | 'list'>(
    settingsFormData?.model && !modelNames.includes(settingsFormData.model) ? 'manual' : 'list',
  );

  const [createIntegration] = useCreateUserGptIntegrationMutation();
  const [editIntegration] = useEditUserGptIntegrationMutation();

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm<FormType>({
    defaultValues: settingsFormData
      ? {
          api: settingsFormData.api,
          description: settingsFormData.description,
          model: settingsFormData.model,
          model_url: settingsFormData.model_uri,
          max_tokens: settingsFormData.max_tokens,
          temperature: settingsFormData.temperature,
          logging: settingsFormData.logging,
          base_url: settingsFormData.base_url,
        }
      : { api: 'openai', logging: false },
  });

  function onSubmit(data: FormType) {
    const checkedData = Object.fromEntries(
      Object.entries(data).filter(([, value]) => (typeof value === 'boolean' ? true : value)),
    ) as FormType;

    try {
      if (settingsFormData) {
        editIntegration({
          params: { gpt_integration_id: settingsFormData.gpt_integration_id },
          body: checkedData,
        });
      } else {
        createIntegration(checkedData);
      }
    } finally {
      onClose();
    }
  }
  const modelOptions: OptionItem[] =
    supportIntegrations?.models.map((integ) => ({
      title: integ.description,
      value: integ.model,
    })) || [];
  // const modelUriRegExp = (model: string) => {
  //   if (!model) return new RegExp('.');

  //   const gptModel = model
  //     .split(' ')
  //     .map((s) => s.toLowerCase())
  //     .join('-');
  //   return new RegExp(`^gpt://[^/]+/${gptModel}/latest$`);
  // };
  return (
    <div className="px-[24px] pt-[24px]">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-[20px]">
        <div className="grid items-center grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="Название интеграции" />
          <Input
            {...register('description', { required: { value: true, message: tf('required') } })}
            maxLength={1000}
            error={errors.description?.message}
          />
        </div>
        <Controller
          render={({ field, fieldState }) => (
            <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
              <CustomLabel label="Модель" />
              <div className="flex items-center gap-[10px]">
                <div className="flex items-center gap-[5px]">
                  <span className="text-3color text-[12px] whitespace-nowrap">Из списка</span>
                  <Toggle
                    checked={modelVariant === 'list'}
                    onChecked={(val) => {
                      const value = val ? 'list' : 'manual';
                      field.onChange('');
                      setModelVariant(value);
                    }}
                  />
                </div>
                {modelVariant === 'manual' ? (
                  <Input
                    defaultValue={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                    error={fieldState.error?.message}
                  />
                ) : (
                  <Select
                    defaultValue={field.value}
                    onChange={(model) => {
                      field.onChange(String(model));
                    }}
                    options={modelOptions}
                    error={fieldState.error?.message}
                    dropWidth={200}
                  />
                )}
              </div>
            </div>
          )}
          control={control}
          name="model"
          rules={{ required: { value: true, message: tf('required') } }}
        />
        <Controller
          render={({ field, fieldState }) => (
            <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
              <CustomLabel label="API протокол" />
              <Select
                defaultValue={field.value}
                onChange={(model) => {
                  field.onChange(String(model));
                }}
                options={[{ title: 'openai', value: 'openai' }]}
                error={fieldState.error?.message}
              />
            </div>
          )}
          control={control}
          name="api"
          rules={{ required: { value: true, message: tf('required') } }}
        />

        <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="Пользовательский ключ авторизации" />
          <Input
            {...register('api_key', {
              required: { value: !settingsFormData, message: tf('required') },
            })}
            error={errors.api_key?.message}
          />
        </div>
        <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="Базовый URL модели" />
          <Input {...register('base_url')} />
        </div>
        <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="URI модели" />
          <Input
            {...register('model_url', {
              required: { value: true, message: tf('required') },
              // pattern: {
              //   value: modelUriRegExp(watch('model')),
              //   message: tf('bad_format', { key: 'URI' }),
              // },
            })}
            disabled={!watch('model')}
            error={errors.model_url?.message}
          />
        </div>
        <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="Максимальное количество токенов" />
          <Input
            {...register('max_tokens', {
              valueAsNumber: true,
              max:
                modelVariant === 'manual'
                  ? undefined
                  : {
                      message: tf('max_len_error', {
                        num: String(
                          supportIntegrations?.models.find((int) => int.model === watch('model'))
                            ?.max_tokens || 1,
                        ),
                      }),
                      value:
                        supportIntegrations?.models.find((int) => int.model === watch('model'))
                          ?.max_tokens || 1,
                    },
              min: { message: tf('min_len_error', { num: 1 }), value: 1 },
            })}
            error={errors.max_tokens?.message}
            type="number"
          />
        </div>
        <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="Температура" />
          <Input
            {...register('temperature', {
              valueAsNumber: true,
              max: { message: tf('max_len_error', { num: '1' }), value: 1 },
              min: { message: tf('min_len_error', { num: '0' }), value: 0 },
            })}
            error={errors.temperature?.message}
            step={0.1}
            type="number"
          />
        </div>
        <div className="grid items-center  grid-cols-[300px_1fr] grid-rows-1">
          <CustomLabel label="Включить логгирование в LLM" />
          <Toggle checked={watch('logging')} onChecked={(val) => setValue('logging', val)} />
        </div>
        <div className="sticky bg-white bottom-0 py-[24px] flex items-center">
          <Button type="submit" label="Сохранить" />
          <Button onClick={onClose} fill="linked" label="Отмена" />
        </div>
      </form>
    </div>
  );
};

export default GptIntegrationForm;
